module.exports = __webpack_public_path__ + "img/vchasno.5441fd6b.png";